// @flow

import type {Reducer} from '@travel-frontend/state-handling-sdk';
import type {CustomerState} from 'redux/v1/customer/CustomerState';

import {combineReducers} from 'redux';

import {dataReducer} from 'redux/v1/customer/data/reducer';
import {putReducer} from 'redux/v1/customer/put/reducer';

export const customerReducer: Reducer<CustomerState> = combineReducers({
  data: dataReducer,
  put: putReducer,
});
